<template>
    <div id="v-accessory-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <!-- 主要部分 -->
        <div class="main-box">
            <!-- 步骤 -->
            <div class="step">
                <img class="pic_bg" :src="$config.resource + 'db_bjt.png'" alt="">
                <div class="row_box">
                    <div class="row curr">
                        <div class="circle">1</div>
                        <p>知识产权调查表</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">2</div>
                        <p>信息安全调查表</p>
                    </div>
                    <div class="wire white"></div>
                    <div class="row curr">
                        <div class="circle">3</div>
                        <p>附件</p>
                    </div>
                </div>
            </div>
            <!-- 附件上传（要求最新复印件，加盖公章） -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>附件上传（要求最新复印件，加盖公章）</p>
                    <div class="remark">备注：有则上传；无则附说明函</div>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">企业法人营业执照：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="licenseFile($event)" 
                                ref="inputer_one" 
                                accept=".pdf" 
                            />
                            <p v-if="company_license!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">开票资料：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="ticketFile($event)" 
                                ref="inputer_two" 
                                accept=".pdf" 
                            />
                            <p v-if="invoice!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">一般纳税人资格认定证书：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="ordinaryFile($event)" 
                                ref="inputer_tri" 
                                accept=".pdf" 
                            />
                            <p v-if="taxpayers_book!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">基本存款账户信息：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="baseFile($event)" 
                                ref="inputer_four" 
                                accept=".pdf" 
                            />
                            <p v-if="deposits!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">纳税信用等级证明：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="gradeFile($event)" 
                                ref="inputer_five" 
                                accept=".pdf" 
                            />
                            <p v-if="taxpayers_level!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">上年度12月份及近1个月的资产负债表：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="liabilitiesFile($event)" 
                                ref="inputer_six" 
                                accept=".pdf" 
                            />
                            <p v-if="liabilities!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">年度12月份及近1个月的利润表：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="profitFile($event)" 
                                ref="inputer_seven" 
                                accept=".pdf" 
                            />
                            <p v-if="profit_list!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">上年度12月份及近1个月的增值税纳税申报表：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="declareFile($event)" 
                                ref="inputer_eight" 
                                accept=".pdf" 
                            />
                            <p v-if="tax_table!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">供货清单：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="supplyFile($event)" 
                                ref="inputer_nine" 
                                accept=".pdf" 
                            />
                            <p v-if="list!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">体系认证书/行业资质证书：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="systemFile($event)" 
                                ref="inputer_ten" 
                                accept=".pdf" 
                            />
                            <p v-if="system_book!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">设备检测仪器清单：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="facilityFile($event)" 
                                ref="inputer_eleven" 
                                accept=".pdf" 
                            />
                            <p v-if="instrument_list!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">审计报告：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="auditFile($event)" 
                                ref="inputer_twelve" 
                                accept=".pdf" 
                            />
                            <p v-if="audit!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">知识产权权属证明：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="ownershipFile($event)" 
                                ref="inputer_thirteen" 
                                accept=".pdf" 
                            />
                            <p v-if="ip_prove!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt">现场/办公室照片：</div>
                        </div>
                        <div class="inp_unit">
                            <input 
                                class="uploadBtn" 
                                name="key" 
                                type="file" 
                                @change="sceneFile($event)" 
                                ref="inputer_fourteen" 
                                accept=".pdf" 
                            />
                            <p v-if="site_pic!=''">已上传</p>
                            <img class="icon" :src="$config.resource + 'scwj.png'" alt="">
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 按钮 -->
            <div class="btn_box">
                <div class="btn gray" v-if="isType!=2&&isReturn==false" @click="onSave">保存草稿</div>
                <div class="btn gray" @click="onBack">上一步</div>
                <div class="btn red" v-if="isType!=2&&isReturn==false" @click="onSubmit">提交终审</div>
                <div class="btn red" v-if="isType==2" @click="toViewPage('/',{})">查看完毕</div>
                <div class="btn red" v-if="isReturn==true" @click="toViewPage('/',{})">返回首页</div>
            </div>
        </div>
        <!-- 弹窗 -->
        <div class="popup" v-if="isPopup">
            <div class="Masked"></div>
            <div class="hint">
                <img class="pic" :src="$config.resource + 'tjcg.png'" alt="">
                <img class="icon" @click="onShut" :src="$config.resource + 'gb.png'" alt="">
            </div>
        </div>
    </div>
</template>
<script>
    import store from '../vuex/store.js';
    export default {
        data(){
            return{
                user:'',// 用户信息
                isType:'',// 1.提交下一步 2.详情下一步 3.重新提交

                company_license:'',//  企业法人营业执照
                invoice:'',//  开票资料
                taxpayers_book:'',//  一般纳税人资格认定证书
                deposits:'',//  基本存款账户信息
                taxpayers_level:'',//  纳税信用等级证明
                liabilities:'',//  上年度12月份及近1个月的资产负债表
                profit_list:'',//  年度12月份及近1个月的利润表
                tax_table:'',//  上年度12月份及近1个月的增值税纳税申报表
                list:'',//  供货清单
                system_book:'',//  体系认证书/行业资质证书
                instrument_list:'',//  设备检测仪器清单
                audit:'',//  审计报告
                ip_prove:'',//  知识产权权属证明
                site_pic:'',//  现场/办公室照片
                isPopup:false,// 提示弹窗
                isReturn:false,// 提交完成
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 保存草稿
            onSave(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.accessory,
                    data: {
                        company_license:that.company_license, //  企业法人营业执照
                        invoice:that.invoice,//  开票资料
                        taxpayers_book:that.taxpayers_book,//  一般纳税人资格认定证书
                        deposits:that.deposits,//  基本存款账户信息
                        taxpayers_level:that.taxpayers_level,//  纳税信用等级证明
                        liabilities:that.liabilities,//  上年度12月份及近1个月的资产负债表
                        profit_list:that.profit_list,//  年度12月份及近1个月的利润表
                        tax_table:that.tax_table,//  上年度12月份及近1个月的增值税纳税申报表
                        list:that.list,//  供货清单
                        system_book:that.system_book,//  体系认证书/行业资质证书
                        instrument_list:that.instrument_list,//  设备检测仪器清单
                        audit:that.audit,//  审计报告
                        ip_prove:that.ip_prove,//  知识产权权属证明
                        site_pic:that.site_pic,//  现场/办公室照片
                        type:2,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                        })
                    }
                })
            },
            // 上一步
            onBack(){
                this.$router.go(-1);
            },
            // 提交终审
            onSubmit(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.accessory,
                    data: {
                        company_license:that.company_license, //  企业法人营业执照
                        invoice:that.invoice,//  开票资料
                        taxpayers_book:that.taxpayers_book,//  一般纳税人资格认定证书
                        deposits:that.deposits,//  基本存款账户信息
                        taxpayers_level:that.taxpayers_level,//  纳税信用等级证明
                        liabilities:that.liabilities,//  上年度12月份及近1个月的资产负债表
                        profit_list:that.profit_list,//  年度12月份及近1个月的利润表
                        tax_table:that.tax_table,//  上年度12月份及近1个月的增值税纳税申报表
                        list:that.list,//  供货清单
                        system_book:that.system_book,//  体系认证书/行业资质证书
                        instrument_list:that.instrument_list,//  设备检测仪器清单
                        audit:that.audit,//  审计报告
                        ip_prove:that.ip_prove,//  知识产权权属证明
                        site_pic:that.site_pic,//  现场/办公室照片
                        type:1,
                    },
                    success(res) {
                        that.isPopup = true
                        that.isReturn = true
                    }
                })
            },
            // 关闭弹窗
            onShut(){
                this.isPopup = false
            },
            // 获取保存草稿
            getDraft(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.accessoryDraft,
                    data: {},
                    success(res) {
                        if(res.data.company_license!=null&&res.data.company_license!=''){// 企业法人营业执照
                            that.company_license = res.data.company_license 
                        }
                        if(res.data.invoice!=null&&res.data.invoice!=''){// 开票资料
                            that.invoice = res.data.invoice 
                        }
                        if(res.data.taxpayers_book!=null&&res.data.taxpayers_book!=''){// 一般纳税人资格认定证书
                            that.taxpayers_book = res.data.taxpayers_book 
                        }
                        if(res.data.deposits!=null&&res.data.deposits!=''){// 基本存款账户信息
                            that.deposits = res.data.deposits 
                        }
                        if(res.data.taxpayers_level!=null&&res.data.taxpayers_level!=''){// 纳税信用等级证明
                            that.taxpayers_level = res.data.taxpayers_level 
                        }
                        if(res.data.liabilities!=null&&res.data.liabilities!=''){// 上年度12月份及近1个月的资产负债表
                            that.liabilities = res.data.liabilities 
                        }
                        if(res.data.profit_list!=null&&res.data.profit_list!=''){// 年度12月份及近1个月的利润表
                            that.profit_list = res.data.profit_list 
                        }
                        if(res.data.tax_table!=null&&res.data.tax_table!=''){// 上年度12月份及近1个月的增值税纳税申报表
                            that.tax_table = res.data.tax_table 
                        }
                        if(res.data.list!=null&&res.data.list!=''){// 供货清单
                            that.list = res.data.list 
                        }
                        if(res.data.system_book!=null&&res.data.system_book!=''){// 体系认证书/行业资质证书
                            that.system_book = res.data.system_book 
                        }
                        if(res.data.instrument_list!=null&&res.data.instrument_list!=''){// 设备检测仪器清单
                            that.instrument_list = res.data.instrument_list 
                        }
                        if(res.data.audit!=null&&res.data.audit!=''){// 审计报告
                            that.audit = res.data.audit 
                        }
                        if(res.data.ip_prove!=null&&res.data.ip_prove!=''){// 知识产权权属证明
                            that.ip_prove = res.data.ip_prove 
                        }
                        if(res.data.site_pic!=null&&res.data.site_pic!=''){// 现场/办公室照片
                            that.site_pic = res.data.site_pic 
                        }
                    }
                }) 
            },
            // 企业法人营业执照
            licenseFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_one
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],1)
                }

                console.log('【that.fil】', that.fil)
            },
            // 开票资料
            ticketFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_two
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],2)
                }

                console.log('【that.fil】', that.fil)
            },
            // 一般纳税人资格认定证书
            ordinaryFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_tri
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],3)
                }

                console.log('【that.fil】', that.fil)
            },
            // 基本存款账户信息
            baseFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_four
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],4)
                }

                console.log('【that.fil】', that.fil)
            },
            // 纳税信用等级证明
            gradeFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_five
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],5)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上年度12月份及近1个月的资产负债表
            liabilitiesFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_six
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],6)
                }

                console.log('【that.fil】', that.fil)
            },
            // 年度12月份及近1个月的利润表 
            profitFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_seven
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],7)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上年度12月份及近1个月的增值税纳税申报表
            declareFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_eight
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],8)
                }

                console.log('【that.fil】', that.fil)
            },
            // 供货清单
            supplyFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_nine
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],9)
                }

                console.log('【that.fil】', that.fil)
            },
            // 体系认证书/行业资质证书
            systemFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_ten
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],10)
                }

                console.log('【that.fil】', that.fil)
            },
            // 设备检测仪器清单
            facilityFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_eleven
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],11)
                }

                console.log('【that.fil】', that.fil)
            },
            // 审计报告
            auditFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_twelve
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],12)
                }

                console.log('【that.fil】', that.fil)
            },
            // 知识产权权属证明
            ownershipFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_thirteen
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],13)
                }

                console.log('【that.fil】', that.fil)
            },
            // 现场/办公室照片
            sceneFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer_fourteen
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],14)
                }

                console.log('【that.fil】', that.fil)
            },
            // 上传
            uploadData(pdf,i){
                const that = this
                that.imgData = new FormData()
                // that.imgData.append('catalog','bourse')
                // 
                // that.imgData.append('name','images')
                that.imgData.append('type','pdf')
                that.imgData.append('pdf',pdf)
                that.imgData.append('name',that.user.company_name)
                console.log('*********1',that.imgData,i)
                that.$request({
                    that: that,
                    api: that.$api.uploadFile,
                    data: that.imgData,
                    headers: { 'content-type': 'multipart/form-data'},
                    discardSign: true,
                    loading: true,
                    success(res){
                        console.log('打印本次结果：',res,i)
                        // console.log('打印本次上传的图片路径：',res.data)
                        if(i==1){//  企业法人营业执照
                            that.company_license = res.data.src
                        }
                        if(i==2){//  开票资料
                            that.invoice = res.data.src
                        }
                        if(i==3){//  一般纳税人资格认定证书
                            that.taxpayers_book = res.data.src
                        }
                        if(i==4){//  基本存款账户信息
                            that.deposits = res.data.src
                        }
                        if(i==5){//  纳税信用等级证明
                            that.taxpayers_level = res.data.src
                        }
                        if(i==6){//  上年度12月份及近1个月的资产负债表
                            that.liabilities = res.data.src
                        }
                        if(i==7){//  年度12月份及近1个月的利润表
                            that.profit_list = res.data.src
                        }
                        if(i==8){//  上年度12月份及近1个月的增值税纳税申报表
                            that.tax_table = res.data.src
                        }
                        if(i==9){//  供货清单
                            that.list = res.data.src
                        }
                        if(i==10){//  体系认证书/行业资质证书
                            that.system_book = res.data.src
                        }
                        if(i==11){//  设备检测仪器清单
                            that.instrument_list = res.data.src
                        }
                        if(i==12){//  审计报告
                            that.audit = res.data.src
                        }
                        if(i==13){//  知识产权权属证明
                            that.ip_prove = res.data.src
                        }
                        if(i==14){//  现场/办公室照片
                            that.site_pic = res.data.src
                        }
                        // console.log('打印查看',that.atlas)
                    },
                    fail(err) {
                        console.log(err)
                        that.$dialog.alert({
                            mes:'上传失败'
                        });
                    }
                })
            },
            // 获取审批后详情
            getDetails(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.particulars,
                    data: {},
                    success(res) {
                        if(res.data.company_license!=null&&res.data.company_license!=''){// 企业法人营业执照
                            that.company_license = res.data.company_license 
                        }
                        if(res.data.invoice!=null&&res.data.invoice!=''){// 开票资料
                            that.invoice = res.data.invoice 
                        }
                        if(res.data.taxpayers_book!=null&&res.data.taxpayers_book!=''){// 一般纳税人资格认定证书
                            that.taxpayers_book = res.data.taxpayers_book 
                        }
                        if(res.data.deposits!=null&&res.data.deposits!=''){// 基本存款账户信息
                            that.deposits = res.data.deposits 
                        }
                        if(res.data.taxpayers_level!=null&&res.data.taxpayers_level!=''){// 纳税信用等级证明
                            that.taxpayers_level = res.data.taxpayers_level 
                        }
                        if(res.data.liabilities!=null&&res.data.liabilities!=''){// 上年度12月份及近1个月的资产负债表
                            that.liabilities = res.data.liabilities 
                        }
                        if(res.data.profit_list!=null&&res.data.profit_list!=''){// 年度12月份及近1个月的利润表
                            that.profit_list = res.data.profit_list 
                        }
                        if(res.data.tax_table!=null&&res.data.tax_table!=''){// 上年度12月份及近1个月的增值税纳税申报表
                            that.tax_table = res.data.tax_table 
                        }
                        if(res.data.list!=null&&res.data.list!=''){// 供货清单
                            that.list = res.data.list 
                        }
                        if(res.data.system_book!=null&&res.data.system_book!=''){// 体系认证书/行业资质证书
                            that.system_book = res.data.system_book 
                        }
                        if(res.data.instrument_list!=null&&res.data.instrument_list!=''){// 设备检测仪器清单
                            that.instrument_list = res.data.instrument_list 
                        }
                        if(res.data.audit!=null&&res.data.audit!=''){// 审计报告
                            that.audit = res.data.audit 
                        }
                        if(res.data.ip_prove!=null&&res.data.ip_prove!=''){// 知识产权权属证明
                            that.ip_prove = res.data.ip_prove 
                        }
                        if(res.data.site_pic!=null&&res.data.site_pic!=''){// 现场/办公室照片
                            that.site_pic = res.data.site_pic 
                        }
                    }
                })
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.$router.push({ path: '/logIn' })
                    }
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getUser()// 用户信息
            that.isType = that.$route.query.type
            if(that.$route.query.type==2){
                that.getDetails()// 获取审批后详情
            }else{
                that.getDraft()// 获取保存草稿
            }
        },
        components:{
            
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/accessory.vue